const PLUGIN_CONFIG_MARKER = 'plugin';

const normalizeText = (value) => String(value ?? '').trim().toLowerCase();

export const isProgramLicenseRecord = (record) => {
  if (!record || typeof record !== 'object') return false;

  const service = normalizeText(record.service ?? record.serviceType);
  const pluginKey = normalizeText(
    record['插件密钥'] ?? record.pluginKey ?? record.plugin_key
  );
  const configName = normalizeText(record.configName ?? record.config_name);

  return !service.includes(PLUGIN_CONFIG_MARKER) &&
    !pluginKey &&
    !configName.includes(PLUGIN_CONFIG_MARKER);
};
